const rub = new Intl.NumberFormat('ru-RU');

/** "5 000 ₽" */
export function money(value: number): string {
  return `${rub.format(Math.round(value))} ₽`;
}

/** "300 000" (no currency, for big guarantees) */
export function compact(value: number): string {
  return rub.format(Math.round(value));
}

const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });
const shortDateFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit' });
const timeFmt = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const weekdayFmt = new Intl.DateTimeFormat('ru-RU', { weekday: 'long' });
const monthShortFmt = new Intl.DateTimeFormat('ru-RU', { month: 'short' });
const dayKeyFmt = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', weekday: 'short' });

export function dateLabel(iso: string): string {
  return dateFmt.format(new Date(iso));
}
/** "26.10" — compact numeric day.month */
export function shortDate(iso: string): string {
  return shortDateFmt.format(new Date(iso));
}
/** "26" — day of month for the schedule date-block */
export function dayNum(iso: string): string {
  return String(new Date(iso).getDate());
}
/** "ОКТ" — uppercase 3-letter month for the schedule date-block */
export function monthAbbr(iso: string): string {
  return monthShortFmt.format(new Date(iso)).replace('.', '').toUpperCase();
}
export function timeLabel(iso: string): string {
  return timeFmt.format(new Date(iso));
}
export function weekday(iso: string): string {
  const w = weekdayFmt.format(new Date(iso));
  return w.charAt(0).toUpperCase() + w.slice(1);
}
export function dateGroupKey(iso: string): string {
  return dayKeyFmt.format(new Date(iso));
}

/** "1-е место" / "—" */
export function placeLabel(position: number | null): string {
  if (position === null) return '—';
  return `${position}-е место`;
}

export function nbsp(s: string): string {
  return s.replace(/ /g, ' ');
}

/* ── Seasons ────────────────────────────────────────────────
   Sequential numbering by absolute id; the first ten get ordinal
   word names, beyond that — a plain «11-й сезон». */
const SEASON_ORDINALS = [
  'Первый', 'Второй', 'Третий', 'Четвёртый', 'Пятый',
  'Шестой', 'Седьмой', 'Восьмой', 'Девятый', 'Десятый',
];

export function seasonName(id: number): string {
  const ordinal = SEASON_ORDINALS[id - 1];
  return ordinal ? `${ordinal} сезон` : `${id}-й сезон`;
}

export function seasonLabel(id: number): string {
  return seasonName(id);
}
